/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMoneyStack = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m10.61 1.037-.546-.323-.514.362-7.12 5.025-1.3.918 1.394.795 1.88 1.071-1.974 1.393-1.271.897 1.347.805 1.858 1.11-1.934 1.364-1.276.9 1.355.804 5.44 3.224 1.36.806 1.36.806 2.72 1.612.546.324.514-.363 7.12-5.024 1.277-.9-1.356-.804-1.861-1.104 1.94-1.369 1.277-.9-1.356-.804-1.861-1.103 1.94-1.37 1.277-.9-1.356-.804-10.88-6.448zM17.838 16l1.316.78-5.33 3.76L12 19.46v-1.944l1.348.89.56.368.54-.382L17.838 16zM10 18.273l-1.07-.634-.93-.55V9.485l5.565-4.373 1.947 1.154-5.122 3.94-.39.3v7.766zm-4-2.37-1.154-.684L6 14.404v1.499zm-1.16-4.857L6 10.227v1.511l-1.16-.692zm7.676 4.417L12 15.035V13.43l1.389.823.546.324.514-.363 3.39-2.392 1.315.78-5.303 3.741-1.335-.88zm-.232-4.19 5.081-3.908 1.789 1.06-5.33 3.761-1.54-.912zM11.72 4.02 6.753 7.923 4.869 6.849l5.307-3.745 1.544.915z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgMoneyStack as MoneyStack };
